import { AdminDepartmentSettings } from '../AdminDepartmentSettings';
import User from '../User';
import { AdminMember } from './AdminMember';
import { AdminReseller } from './AdminReseller';
import { DepartmentArray } from './arrayModels/DepartmentArray';
import { Department } from './Department';
export class AdminDepartment {
    companyId;
    companyName;
    note;
    tag;
    ico;
    createdAt;
    disableStatus;
    owner;
    responsiblePerson;
    contactPerson;
    seller;
    tier;
    loggerCount;
    deviceCount;
    userCount;
    issuesSummary;
    settings;
    application;
    isFeatureExceeded;
    hasActiveService;
    acceptanceProtocolStatus;
    companyAddress;
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => AdminDepartment.define(et));
        }
        else if (data != null) {
            return AdminDepartment.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let company = new AdminDepartment();
        company.companyId = data.CompanyId;
        company.companyName = data.CompanyName;
        company.ico = data.Ico;
        company.note = data.Note;
        company.createdAt = data.CreatedAt;
        company.owner = User.fromApi(data.Owner);
        company.loggerCount = data.LoggerCount;
        company.deviceCount = data.DeviceCount;
        company.userCount = data.UserCount;
        company.tier = data.Tier;
        company.settings = AdminDepartmentSettings.fromApi(data.Settings);
        company.isFeatureExceeded = data.IsFeatureExceeded;
        company.hasActiveService = data.HasActiveService;
        company.acceptanceProtocolStatus = data.AcceptanceProtocolStatus;
        company.disableStatus = {
            isDisabled: data.IsDisabled,
            disabledAt: data.DisabledAt,
            disabledReason: data.DisabledReason
        };
        if (data.Tag) {
            company.tag = data.Tag;
        }
        if (data.ResponsiblePerson) {
            company.responsiblePerson = AdminMember.fromApi(data.ResponsiblePerson);
        }
        if (data.ContactPersons) {
            company.contactPerson = data.ContactPersons;
        }
        if (data.Seller) {
            company.seller = AdminReseller.fromApi(data.Seller);
        }
        if (data.Issues) {
            company.issuesSummary = company.remapIssueSummary(data.Issues);
        }
        if (data.Application) {
            company.application = data.Application;
        }
        company.companyAddress = data.CompanyAddress;
        return company;
    }
    remapIssueSummary(issues) {
        return issues.map((issue) => ({
            type: issue.Type,
            alarmLevel: issue.AlarmLevel,
            notAcknowledged: issue.NumOfNotAcknowledged,
            notResolved: issue.NumOfUnresolved
        }));
    }
    static sortByName(companies) {
        return companies.sort(function (a, b) {
            let aId = a ? a.companyName.toLowerCase() : '';
            let bId = b ? b.companyName.toLowerCase() : '';
            return aId < bId ? -1 : aId > bId ? 1 : 0;
        });
    }
    static convertToUserDepartments(adminDepartments) {
        let userDepartments = [];
        adminDepartments.forEach((adminDepartment) => {
            userDepartments.push(AdminDepartment.convertToUserDepartment(adminDepartment));
        });
        return userDepartments;
    }
    static convertToUserDepartment(adminDepartment) {
        let department = new Department();
        department.id = adminDepartment.companyId;
        department.name = adminDepartment.companyName;
        department.disableStatus = adminDepartment.disableStatus;
        department.createdAt = adminDepartment.createdAt;
        return department;
    }
    static convertToAdminDepartment(department) {
        let adminDepartment = new AdminDepartment();
        adminDepartment.companyId = department.id;
        adminDepartment.companyName = department.name;
        adminDepartment.createdAt = department.createdAt;
        return adminDepartment;
    }
    static convertToDepartmentsArray(adminDepartments) {
        let userDepartments = [];
        adminDepartments.forEach((adminDepartment) => {
            let department = new Department();
            department.id = adminDepartment.companyId;
            department.name = adminDepartment.companyName;
            department.createdAt = adminDepartment.createdAt;
            department.acceptanceProtocolStatus = adminDepartment.acceptanceProtocolStatus;
            department.isFeatureExceeded = adminDepartment.isFeatureExceeded;
            department.hasActiveService = adminDepartment.hasActiveService;
            department.issuesSummary = adminDepartment.issuesSummary;
            userDepartments.push(department);
        });
        return new DepartmentArray(userDepartments);
    }
}
export var FeatureExceededStatus;
(function (FeatureExceededStatus) {
    FeatureExceededStatus["FEATURE_EXCEEDED"] = "featureExceeded";
})(FeatureExceededStatus || (FeatureExceededStatus = {}));
